module.exports = __webpack_public_path__ + "img/back.21de0687.svg";